import { FC } from "react";
import { Select, Spin } from "antd";
import { ResponseMode } from "./aiStatus";

export const RESPONSE_MODE_OPTIONS = [
  { label: "AI自動回答", value: "ai" as ResponseMode },
  { label: "有人対応", value: "manual" as ResponseMode },
];

type ResponseModeControlProps = {
  isAdmin: boolean;
  value: ResponseMode;
  onChange: (value: ResponseMode) => void;
  loading?: boolean;
};

const ResponseModeControl: FC<ResponseModeControlProps> = ({
  isAdmin,
  value,
  onChange,
  loading = false,
}) => {
  if (!isAdmin) return null;

  return (
    <div className="response-mode-control form-item-custom">
      <span className="response-mode-control__label">回答方式</span>
      <Select
        aria-label="回答方式"
        value={value}
        disabled={loading}
        onChange={(nextValue) => onChange(nextValue as ResponseMode)}
        className="select-custom"
        suffixIcon={loading ? <Spin size="small" /> : undefined}
        options={RESPONSE_MODE_OPTIONS}
      />
    </div>
  );
};

export default ResponseModeControl;
